import {Injectable, APP_INITIALIZER, Inject} from '@angular/core';
import {DeviceService} from '../devices/device.service';
import {BASE_CLIENT, BaseClient} from '../client/base.client';
import {preloaderFinished} from './preloader';
import {InfoService} from "../info/info.service";

@Injectable({
  providedIn: 'root'
})
export class StartupService {

  constructor(private deviceService: DeviceService,
              private systemInfoService: InfoService,
              @Inject(BASE_CLIENT) private baseclient: BaseClient) {
  }

  load(): Promise<any> {
    if (this.baseclient.openDev === true) {
      preloaderFinished();
      return new Promise<any>((resolve, reject) => resolve(true));
    }
    return this.deviceService.native.auth().then(() => this.systemInfoService.initSystemInfo());
  }
}

export function StartupServiceFactory(
  startupService: StartupService,
  // tslint:disable-next-line: ban-types
): Function {
  return () => startupService.load();
}

export const APPINIT_PROVIDES = [
  StartupService,
  {
    provide: APP_INITIALIZER,
    useFactory: StartupServiceFactory,
    deps: [StartupService],
    multi: true,
  },
];
